import { GridRequest } from 'projects/app-core/src/models/gridRequest';

export enum ReengageAuditSort {
  CREATED_AT = 'CREATED_AT',
}

export enum ReengageAuditFilter {
  PARTNER_ID = 'PARTNER_ID',
  LIFECYCLE_STATE = 'LIFECYCLE_STATE',
  CAPABILITY_ID = 'CAPABILITY_ID',
  DISPATCH_STATUS = 'DISPATCH_STATUS',
}

export enum ReengageAuditSearch {
  EMAIL = 'EMAIL',
}

export enum ReengageAuditDateFilter {
  CREATED_AT = 'CREATED_AT',
}

export interface ReengageAuditGridRequest
  extends GridRequest<
    ReengageAuditSort,
    ReengageAuditFilter,
    ReengageAuditSearch,
    ReengageAuditDateFilter
  > {}

export enum ReengageAuditLifecycleState {
  DORMANT = 'DORMANT',
  RETURNING = 'RETURNING',
  RESURRECTING = 'RESURRECTING',
}

export enum ReengageAuditDispatchStatus {
  SCHEDULED = 'scheduled',
  DISPATCHED = 'dispatched',
  SEND_SKIPPED_PERMISSION = 'send_skipped_permission',
  SEND_FAILED = 'send_failed',
  SHADOW_SUPPRESSED = 'shadow_suppressed',
  NO_SEND_BY_SELECTOR = 'no_send_by_selector',
}
